/**
 * Helper function that returns a query param string for the params from the current URL.
 * This is meant to help with auth flows like those for integrations like Canva.
 * If there are no params, an empty string is returned,
 * else a string like "?key1=val1&key2=val2" is returned.
 */
export function getCurrentQueryParamsStr() {
  const inParams = new URLSearchParams(window.location.search)
  let paramStr = inParams.toString()
  if (paramStr !== '') {
    paramStr = `?${paramStr}`
  }
  return paramStr
}

/**
 * Custom hook for global authentication management
 * Provides utilities for session management and authentication checks
 */
export function useAppAuth() {
  return {
    getCurrentQueryParamsStr
  }
}

export default useAppAuth
